import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doGet, doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

/* retrieve entities data */

export const GetEntityLevelData = createAsyncThunk(
    "entityLevelData",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.getEntitiesData, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const GetEntityLevelDataSlice = createSlice({
    name: "entityLevelData",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        getEntityLevelDataReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            }
        }
    },
    extraReducers: {
        [GetEntityLevelData.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.data = payload;
            state.error = false;
        },
        [GetEntityLevelData.pending]: (state) => {
            state.isLoading = true;
            state.data = false;
            state.error = null;
        },
        [GetEntityLevelData.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

/*Entity List */

export const entityList = createAsyncThunk(
    "entityList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await doGet(urls?.entityList);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const entityListSlice = createSlice({
    name: "entityList",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        entityListReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            }
        }
    },
    extraReducers: {
        [entityList.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.data = payload;
            state.error = false;
        },
        [entityList.pending]: (state) => {
            state.isLoading = true;
            state.data = false;
            state.error = null;
        },
        [entityList.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

/* Entity Wise Data */

export const GetItemLevelData = createAsyncThunk(
    "itemLevelData",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.itemLevelData, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const GetItemLevelDataSlice = createSlice({
    name: "itemLevelData",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        itemlevelDataReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            }
        }
    },
    extraReducers: {
        [GetItemLevelData.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.data = payload;
            state.error = false;
        },
        [GetItemLevelData.pending]: (state) => {
            state.isLoading = true;
            state.data = false;
            state.error = null;
        },
        [GetItemLevelData.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})


/* Entity Files List */

export const entityFilesList = createAsyncThunk(
    "entityFilesList",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.entityListData, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const entityFilesListSlice = createSlice({
    name: "entityFilesList",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        entityFilesListReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            }
        }
    },
    extraReducers: {
        [entityFilesList.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.data = payload;
            state.error = false;
        },
        [entityFilesList.pending]: (state) => {
            state.isLoading = true;
            state.data = false;
            state.error = null;
        },
        [entityFilesList.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})


export const { getEntityLevelDataReset } = GetEntityLevelDataSlice.actions;
export const { itemlevelDataReset } = GetItemLevelDataSlice.actions;
export const { entityFilesListReset } = entityFilesListSlice.actions;
export const { entityListReset } = entityListSlice.actions;